'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Border = undefined;

var _systemComponents = require('system-components');

var _systemComponents2 = _interopRequireDefault(_systemComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Border = exports.Border = (0, _systemComponents2.default)({
  border: 1,
  borderColor: 'gray'
}, 'space', 'width', 'color');

Border.displayName = 'Border';

exports.default = Border;


//////////////////
// WEBPACK FOOTER
// ./~/rebass/dist/Border.js
// module id = 84
// module chunks = 35783957827783 114276838955818 225143243664639